import React, {useEffect, useState} from 'react'
import PropTypes from 'prop-types'


export const BreakPointContext = React.createContext({
    isMobile: null,
    isTablet: null,
    isDesktop: null,
});


export default function BreakPointContextProvider(props) {

    const breakingPoints = {
        xl: 1200,
        lg: 998,
        md: 767,
        xs: 598
    }

    const [breakingPoint, setBreakPoint] = useState({
            isMobile: true,
            isTablet: false,
            isDesktop: false,
    })
    const setDevices = () => {
        switch (getDevices()) {
            case "xtra-large":
                //console.log('is desktop')

                setBreakPoint({
                    isMobile: false,
                    isTablet: false,
                    isDesktop: true,
                })
                break;
            case "large":
               // console.log('is desktop')
                setBreakPoint({
                    isMobile: false,
                    isTablet: false,
                    isDesktop: true,
                })
                break;
            case "medium":
               // console.log('is tablet')

                setBreakPoint({
                    isMobile: false,
                    isTablet: true,
                    isDesktop: false,
                })
                break;
            case "small":
               // console.log('is tablet')

                setBreakPoint({
                    isMobile: false,
                    isTablet: true,
                    isDesktop: false,
                })
                break;
            case "xtra-small":
                console.log('is mobile')

                setBreakPoint({
                    isMobile: true,
                    isTablet: false,
                    isDesktop: false,
                })
                break;
            
            default:
                setBreakPoint({
                    isMobile: false,
                    isTablet: false,
                    isDesktop: true,
                })
                break;
        }
    }

    const getDevices = ()=>{
        const {xl, lg, md, xs} = breakingPoints
        const windowWidth = window.innerWidth
        //console.log(windowWidth)

        if (windowWidth >= xl) return "xtra-large"
        if (windowWidth < xl && windowWidth >= lg) return "large"
        if (windowWidth < lg && windowWidth >= md) return "medium"
        if (windowWidth < md && windowWidth >= xs) return "small"
        if (windowWidth < xs) return "xtra-small"
    }

    useEffect(()=>{
        setDevices()
        window.addEventListener('resize', setDevices, true)
        return ()=>{
            window.removeEventListener('resize', setDevices )
        }
    }, [])


    return (
        <BreakPointContext.Provider value={breakingPoint}>
            {props.children}
        </BreakPointContext.Provider>
    )
}

BreakPointContextProvider.propTypes = {
    children: PropTypes.node
};
